(() => {
  'use strict';

  if (window.__mellerPdpAddToCartInpReady) return;
  window.__mellerPdpAddToCartInpReady = true;

  const BUSY_ATTR = 'data-meller-pdp-atc-busy';
  const PREPARED_ATTR = 'data-meller-pdp-atc-prepared';

  const getButton = (target) => {
    if (!target || !target.closest) return null;
    return target.closest('.meller-add-to-cart-button');
  };

  const getForm = (target) => {
    if (!target || !target.closest) return null;
    return target.closest('form');
  };

  const getFormButton = (form) => {
    if (!form || !form.querySelector) return null;
    return form.querySelector('.meller-add-to-cart-button');
  };

  const clearBusy = (form) => {
    if (!form) return;

    const button = getFormButton(form);

    form.removeAttribute(BUSY_ATTR);

    if (button) {
      button.removeAttribute('aria-busy');
    }
  };

  document.addEventListener(
    'pointerdown',
    (event) => {
      const button = getButton(event.target);

      if (!button || button.disabled) return;

      button.setAttribute(PREPARED_ATTR, 'true');
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (!form || !form.querySelector) return;

      const button = getFormButton(form);

      if (!button || button.disabled) return;

      const variantInput = form.querySelector('input[name="id"]');

      if (!variantInput || variantInput.disabled || !variantInput.value) return;

      if (form.getAttribute(BUSY_ATTR) === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      form.setAttribute(BUSY_ATTR, 'true');
      button.setAttribute('aria-busy', 'true');

      window.setTimeout(() => {
        clearBusy(form);
      }, 2600);
    },
    true
  );

  [
    'cart:update',
    'cart:updated',
    'cart:refresh',
    'cart:change',
    'product-form:success',
    'ajaxProduct:added'
  ].forEach((eventName) => {
    document.addEventListener(
      eventName,
      () => {
        const busyForms = document.querySelectorAll('form[' + BUSY_ATTR + '="true"]');

        busyForms.forEach((form) => {
          clearBusy(form);
        });
      },
      true
    );
  });
})();
